import { render, staticRenderFns } from "./BuilderPage.vue?vue&type=template&id=c71cca90&"
import script from "./BuilderPage.vue?vue&type=script&lang=js&"
export * from "./BuilderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports